import { DisplayableProduct, ProductModel } from "../../../../../store/api/upsellApi";
import { Box, ButtonBase, Card } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Fastfood } from "@mui/icons-material";
import React, { ReactElement } from "react";
import AddIcon from "@mui/icons-material/Add";

export function Products({
  products,
  reorderable = false,
  allowAdd = false,
  onAdd,
  children,
}: {
  products: ProductModel[];
  reorderable?: boolean;
  allowAdd?: boolean;
  onAdd: () => void;
  children: (product: DisplayableProduct, index: number) => ReactElement;
}) {
  return (
    <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
      {products.map((product, index) => children(product, index))}
      {allowAdd ? (
        <ButtonBase onClick={onAdd} title={"Add a product"}>
          <Card
            elevation={0}
            sx={{
              border: `1px dotted ${grey[800]}`,
              width: "100%",
              py: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // bit convoluted.
              //   (font-size title * line-height)
              // + (font-size id    * line-height)
              // + vertical padding on gridArea product
              // + vertical padding on grid itself
              height: "calc(1em * 1.5 + 0.9em * 1.5 + 4px + 16px)",
            }}
          >
            <AddIcon sx={{ color: "gray", display: "inline" }} />{" "}
            <Fastfood color={"primary"} sx={{ display: "inline" }} />
          </Card>
        </ButtonBase>
      ) : null}
    </Box>
  );
}
